import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface TimeBasedSettingForCallersGroupResponse extends MiddlewareAPIResponse
{
    
}

export class TimeBasedSettingForCallersGroupResponseDtoImpl extends MiddlewareDtoImpl implements TimeBasedSettingForCallersGroupResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/mytunes/timebasedsettingforcallersgroup/timebasedsettingforcallersgroupresponse.tsx